import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { StatusLabel, Tooltip, ExternalLink } from 'next/components/ui';

const LabelWrapper = styled.div`
  width: 200px;
  white-space: initial;
  font-weight: var(--normal);

  ${ExternalLink} {
    color: inherit;
    :hover {
      color: inherit;
    }
    text-decoration: underline;
  }
`;

const UpgradeBadge = styled(StatusLabel)`
  font-weight: var(--normal);
  word-break: keep-all;
  user-select: none;
`;

export default function UpgradeTag({ tooltipContent }) {
  return (
    <Tooltip
      delay={0}
      placement="top"
      timeout={200}
      persist
      disabled={!tooltipContent}
      label={<LabelWrapper>{tooltipContent}</LabelWrapper>}
      wrapped
    >
      <UpgradeBadge label="Upgrade" icon="magic" />
    </Tooltip>
  );
}

UpgradeTag.propTypes = {
  tooltipContent: PropTypes.node.isRequired,
};
